import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useDesignContext } from '@klarna/designtokens';
import { defaultColorVariables } from '@bubble-ui/particle-default-color-variables';
import { defaultSpaceTokens } from '@bubble-ui/particle-default-space-tokens';
import { useBreakpoints } from '@bubble-ui/provider-responsive';
import { platformSelect } from '@bubble-ui/util-platform';
import { getActiveValue } from './useStyles/breakpointUtils';

// Exclusion to be removed as part of UI-4225

export var getColor = (designContext, color, args) => typeof color === 'string' && designContext.hasTokenInContext(color) ? designContext.get(color, args).toString() : color;
export var useColor = color => {
  var designContext = useDesignContext(defaultColorVariables);
  var breakpoints = useBreakpoints();
  var activeColor = getActiveValue(breakpoints, color);
  return getColor(designContext, activeColor);
};
export var getRadius = (designContext, radius) => {
  if (typeof radius !== 'string') {
    return radius;
  }
  return designContext.hasTokenInContext(radius) ? designContext.get(radius).value() : parseInt(radius, 10) || 0;
};
export var getSpace = function (designContext, space) {
  var {
    convertToNumber
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    convertToNumber: false
  };
  if (typeof space === 'string' && designContext.hasTokenInContext(space)) {
    return designContext.get(space).value();
  }
  if (convertToNumber) {
    return typeof space === 'number' ? space : typeof space === 'string' ? parseInt(space, 10) || 0 : 0;
  }
  return space;
};
export var useSpace = space => {
  var designContext = useDesignContext(defaultSpaceTokens);
  var breakpoints = useBreakpoints();
  var activeSpace = getActiveValue(breakpoints, space);
  return getSpace(designContext, activeSpace, {
    convertToNumber: true
  });
};
export var getShadow = (designContext, shadow) => {
  if (typeof shadow === 'string' && designContext.hasTokenInContext(shadow)) {
    var value = designContext.get(shadow);
    return platformSelect({
      android: _objectSpread({}, value.stylesAndroid()),
      ios: _objectSpread({}, value.stylesIos()),
      web: _objectSpread({}, value.stylesWeb())
    });
  }
  return {};
};
//# sourceMappingURL=tokenUtils.js.map